import { request } from '../../lib/request_other';

// 全局搜索 == 帮助中心，使用手册
export function searchKv(params) {
    return request({
        url: `{#npgw}/searchnav/search/ce`,
        method: 'GET',
        params,
        timeout: 30 * 1000,
    });
}
// 搜索埋点
export function addSearchLog(data) {
    return request({
        url: `{#npgw}/searchnav/dataSource/ce/addSearchInfo`,
        method: 'post',
        data,
        timeout: 30 * 1000,
    });
}
